import { countries, usStates } from './constants';

export const getAvatarInitials = (name?: string) => {
  return name
    ?.split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
};

export const displayLocation = (params: {
  city?: string;
  countryCode?: string;
  state?: string;
}): string | undefined => {
  const { city, countryCode, state } = params;

  if (!city && !countryCode && !state) return undefined;
  let country = countryCode;
  let stateFormatted = state;

  if (countryCode === 'US') {
    country = countries.find((country) => country.code === countryCode)?.name ?? countryCode;
    stateFormatted = usStates.find((usState) => usState.code === state)?.name ?? state;
  }

  return [city, state, country].filter(Boolean).join(', ');
};
